export const buttonThemes = {
  nav_red: {
    background: 'var(--app-red)',
    color: '#fff',
    labelWidth: 'auto'
  },
  nav_black: {
    background: '#1a1a1a',
    color: '#fff',
    labelAlign: 'start'
  },
  nav_gray: {
    background: '#2d2f38',
    color: '#e6e7e8',
    borderRight: '1px solid #4a4d50',
    labelAlign: 'start',
    maxWidth: '100px',
  },
  nav_light: {
    color: '#b0b3b8',
  },

  units: {
    labelWidth: 'auto',
    color: '#b0b3b8',
  },

  buttonGroupDef: {
    labelAlign: 'center',
    labelWidth: '100%',
    background: 'transparent',
    height: '34px',
    checked: 'var(--app-red)',
    unchecked: '#2d2f38'
  },

  buttonGroupBig: {
    iconSize: '50px',
  },

  buttonGroupBigNav: {
    iconSize: '38px',
    width: '40px',
    justify: 'start'
  },

  furnitureGroup: {
    iconSize: '90px',
    checked: 'none',
    unchecked: 'none',
  },

  furnitureGroupNav: {
    iconSize: '50px',
    checked: 'none',
    unchecked: 'none',
  },

  deviceGroup: {
    iconSize: '50px',
    checked: 'none',
    unchecked: 'none',
  },

  acousticGroup: {
    width: '82px',
    size: '16px',
    checked: 'var(--app-red)',
    unchecked: '#2d2f38',
    label_checked: '#fff',
    label_unchecked: '#b0b3b8',
    uppercase: true
  },

  acousticGroupNav: {
    width: '64px',
    height: '32px',
    size: '12px',
    checked: 'var(--app-red)',
    unchecked: '#2d2f38',
    label_checked: '#fff',
    label_unchecked: '#b0b3b8',
    uppercase: true,
    borderRadius: '4px'
  },

  familyGroup: {
    width: '200px',
    size: '44px',
    checked: 'var(--app-red)',
    unchecked: '#2d2f38',
    label_checked: '#fff',
    label_unchecked: '#b0b3b8',
  },

  navGroup: {
    iconScale: 1.2,
    justify: 'start',
    checked: 'var(--app-red)',
    unchecked: '#1e1e1e',
    label_checked: '#fff',
    label_unchecked: '#b0b3b8',
  },

  actionGroup: {
    background: 'transparent',
    height: '36px',
    width: '64px',
    checked: 'var(--app-red)',
    unchecked: '#74777a',
    iconScale: '1.2'
  },

  dotGroup: {
    height: '8px',
    maxWidth: '8px',
    maxHeight: '8px',
    border: '4px',
    radius: '50%',
  }
}

export const iconThemes = {
  'door_move': {
    'icon_stroke': '#e6e7e8',
    'icon_fill': '#e6e7e8',
  },
  'button_selected': {
    'border_stroke': '#e6e7e8',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    border: '1px solid #4a4d50',
  },

  'button_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': '#2d2f38',
    'icon_stroke': '#e6e7e8',
    'icon_fill': '#e6e7e8',
    border: '1px solid transparent'
  },

  'button_disabled': {
    'border_stroke': '#4a4d50',
    'border_fill': '#4a4d50',
    'icon_stroke': '#1a1a1a',
    'icon_fill': '#1a1a1a',
  },

  'button_disabled-dim': {
    'border_stroke': '#2d2f38',
    'border_fill': '#2d2f38',
    'icon_stroke': '#1a1a1a',
    'icon_fill': '#1a1a1a',
  },

  'nav_active': {
    'border_stroke': 'none',
    'border_fill': 'none',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
  },

  'nav_inactive': {
    'border_stroke': 'none',
    'border_fill': 'none',
    'icon_stroke': '#74777a',
    'icon_fill': '#74777a',
  },

  'coverage_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    'color': 'var(--app-red)'
  },

  'coverage_inactive': {
    'border_stroke': '#74777a',
    'border_fill': '#74777a',
    'icon_stroke': '#1e1e1e',
    'icon_fill': '#1e1e1e',
  },

  'furniture_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
  },
  
  'furniture_inactive': {
    'border_stroke': '#74777a',
    'border_fill': 'none',
    'icon_stroke': '#74777a',
  },

  'device_selected': {
    'border_stroke': '#e6e7e8',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    border: '1px solid transparent',
  },

  'acoustic_inactive': {
    border: '1px solid #74777a',
  },

  'acoustic_nav_active': {
    border: '1px solid #74777a',
    background: '#4a4d50',
    color: '#fff'
  },

  'acoustic_nav_inactive': {
    border: '1px solid #74777a',
    background: '#2d2f38',
    color: '#b0b3b8'
  },

  'dot_selected': {
    background: 'var(--app-red)',
  },
  
  'dot_active': {
    background: '#2d2f38',
  }
}

export const modalThemes = {
  splash: {
    labelAlign: 'start',
    labelWidth: '28%',
    lineHeight: '32px',
  },
  default: {
    headerPadding: '16px 24px',
    headerBackground: '#1a1a1a',
    headerColor: '#fff',
    background: '#1e1e1e',
    bodyPadding: '24px 24px 0px 24px',
    labelAlign: 'start',
    labelWidth: 'auto',
    inputBackground: '#2d2f38',
    footerBackground: '#2d2f38',
  },
  tutorial: {
    headerPadding: '16px 24px',
    headerBackground: '#1e1e1e',
    headerColor: '#fff',
    headerAlign: 'center',
    headerBorder: '#4a4d50',
    background: '#1e1e1e',
    bodyPadding: '24px 24px 0px 24px',
    footerBackground: '#2d2f38',
    footerMargin: '0.5rem!important'
  },
  requestQuote: {
    headerPadding: '24px 32px 16px',
    headerBackground: '#1e1e1e',
    headerColor: '#fff',
    headerAlign: 'left',
    headerBorder: false,
    background: '#1e1e1e',
    color: '#e6e7e8',
    bodyPadding: '0 32px 24px',
    footerBackground: '#1e1e1e',
    footerPadding: '24px 32px 40px',
    footerBorder: false,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
  },
  loading: {
    headerPadding: '0px',
    headerBackground: 'transparent',
    headerColor: 'transparent',
    headerBorder: false,
    background: '#1e1e1e',
    color: '#e6e7e8',
    footerBackground: 'transparent',
    footerPadding: '0px',
    footerBorder: false,
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    opacity: 1,
    minWidth: '300px'
  }
};